import { StrictMode, Suspense } from "react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router-dom";
import "./index.css";
import { router } from "./App";
import { AuthProvider } from "@/lib/auth-provider";
import { Spinner } from "@/components/ui/spinner";
import { Notification } from "@/components/ui/notifications";
import { APIProvider } from "@vis.gl/react-google-maps";

const queryClient = new QueryClient();

createRoot(document.getElementById("root")).render(
    <StrictMode>
        <QueryClientProvider client={queryClient}>
            <AuthProvider>
                <APIProvider apiKey="AIzaSyBGpbdsy42seNGf2rITGz9CYqKTT8JWPa4">
                    <Suspense
                        fallback={
                            <div className="flex h-screen w-screen items-center justify-center">
                                <Spinner size="xl" />
                            </div>
                        }
                    >
                        <RouterProvider router={router} />
                        <Notification />
                    </Suspense>
                </APIProvider>
            </AuthProvider>
        </QueryClientProvider>
    </StrictMode>,
);
